import { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import avatar from "assets/svg/avatar.svg";
import down from "assets/svg/down.svg";
import menu from "assets/svg/menu.svg";
import menuCloseBlack from "assets/svg/menuCloseBlack.svg";
import menuBlack from "assets/svg/menuBlack.svg";
import lisapropLogo from "assets/png/LisapropLogo.png";
import { formatDateInput2 } from "components/FormatDate";
import { useAuth } from "context/AuthContext";

const Navbar = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const navRef = useRef<HTMLDivElement>(null);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const theStoredToken = localStorage.getItem("accessToken");
  const dropdownRef = useRef<any>(null);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowProfileDropdown(false);
      }
    };

    const handleEscapeKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setShowProfileDropdown(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, []);

  const navbarLinks = [
    { name: "Home", nav: "/" },
    { name: "About", nav: "/about-us" },
    { name: "Solutions", nav: "/solutions" },
    { name: "Contact Us", nav: "/contact-us" },
  ];

  return (
    <>
      {!showMobileMenu && (
        <header
          ref={navRef}
          className={` flex font-inter ${
            showMobileMenu ? "h-screen  text-black" : ""
          } justify-between text-[#333333]  bg-white items-center px-[20px] lg:px-[84px] h-[80px] transition-height duration-300 fixed top-0 left-0 z-[100] w-[100%]  ${
            location.pathname !== "/" ? "  text-[#1E1E1E]" : ""
          }  shadow-md ${
            location.pathname === "/"
              ? "border-b-[#4e5e5c]"
              : "border-b-[#E9E9E9] "
          }  `}
        >
          <button
            onClick={() => {
              navigate("/");
              setShowMobileMenu(false);
            }}
            className=" cursor-pointer  "
          >
            <img
              src={lisapropLogo}
              alt="logo"
              className="lg:w-[150px] md:w-full"
            />
          </button>

          <div className="hidden md:flex gap-2 lg:gap-6 xl:gap-[66px] ">
            <nav className="flex items-center gap-2 lg:gap-6 xl:gap-[66px] duration-300 transition-transform ease-in-out  ">
              {navbarLinks?.map((navlink, index) => {
                return (
                  <button
                    onClick={() => navigate(navlink.nav)}
                    key={index}
                    className={` ${
                      location.pathname === navlink.nav
                        ? "text-[#202020] font-[600] "
                        : ""
                    } hover:font-[600] text-[12px] lg:text-[14px] w-[90px]`}
                  >
                    {navlink.name}
                  </button>
                );
              })}
            </nav>
          </div>
          <div className="hidden md:flex gap-2 lg:gap-6 xl:gap-[40px] text-primary font-[500]">
            <div
              className={` ${
                !theStoredToken ? "gap-[20px] " : "gap-3"
              } flex items-center `}
            >
              {!theStoredToken ? (
                <>
                  <button onClick={() => navigate("/login")}>Login</button>
                  <button
                    className="px-4 py-[4px] xl:px-8 md:py-[10px] bg-primary rounded-[8px] text-white transition-all duration-500 ease-in-out text-[12px] xl:text-[14px]"
                    onClick={() => navigate("/sign-up")}
                  >
                    Get Started
                  </button>
                </>
              ) : (
                <>
                  <div>
                    <p className="text-[#333333] text-[14px] ">
                      {user?.firstName}
                    </p>
                    <p className="text-[#9EA1AB] text-[12px] ">
                      {user?.role === "owner"
                        ? "Property Owner"
                        : user?.role === "developer"
                        ? "Property Developer"
                        : user?.role === "admin"
                        ? "Admin"
                        : ""}
                    </p>
                  </div>
                  <button
                    disabled={!user}
                    onClick={() => navigate("/dashboard")}
                  >
                    <img
                      src={
                        user?.profilePicture === ""
                          ? avatar
                          : user.profilePicture
                      }
                      className="rounded-full w-[32px] h-[32px]  "
                      alt="user"
                    />
                  </button>
                  <button
                    onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                  >
                    <img
                      src={down}
                      className="rounded-full w-[32px] h-[32px]  "
                      alt="dropdown"
                    />
                  </button>
                </>
              )}
            </div>
          </div>

          {!showMobileMenu || location.pathname !== "/" ? (
            <button
              onClick={() => setShowMobileMenu(true)}
              className="md:hidden flex "
            >
              <img src={menuBlack} alt="menu" />
            </button>
          ) : !showMobileMenu || location.pathname !== "/" ? (
            <button
              onClick={() => setShowMobileMenu(true)}
              className="md:hidden flex "
            >
              <img src={menu} alt="menu" />
            </button>
          ) : null}
          {showProfileDropdown && (
            <div className="bg-white rounded-[8px] shadow-md font-nunito flex flex-col gap-1  justify-center p-2 absolute top-[60px] right-[25px] z-[30]  items-start  ">
              <button
                onClick={() => {
                  navigate("/profile");
                  setShowProfileDropdown(false);
                }}
                className="py-1 text-[14px] w-full text-start hover:bg-[#EFEFEF] rounded-[4px] px-3 cursor-pointer "
              >
                Profile
              </button>
              <button
                onClick={() => {
                  localStorage.clear();
                  navigate("/");
                  setShowProfileDropdown(false);
                }}
                className="py-1 text-[14px] text-red-500 w-full text-start hover:bg-[#EFEFEF] rounded-[4px] px-3 cursor-pointer "
              >
                Log out
              </button>
            </div>
          )}
        </header>
      )}

      {showMobileMenu && (
        <header
          ref={navRef}
          className={`flex flex-col ${
            showMobileMenu ? "h-screen bg-white text-black" : ""
          } font-nunito  items-center px-[20px] h-[80px] transition-height duration-300 fixed top-0 left-0 z-[100] w-[100%]   `}
        >
          <div className="flex items-center justify-between w-full mt-10 ">
            <button onClick={() => navigate("/")} className=" cursor-pointer">
              <img
                src={lisapropLogo}
                alt="logo"
                className="lg:w-[150px] md:w-full"
              />
            </button>
            <button
              onClick={() => setShowMobileMenu(false)}
              className="md:hidden flex border-[1px] border-[#03045E] rounded-full p-2 "
            >
              <img src={menuCloseBlack} alt="menu" className="w-[10px] " />
            </button>
          </div>

          <div className=" flex flex-col gap-[60px] mt-10 w-full px-6 font-nunito ">
            <nav className="flex flex-col items-center gap-6 duration-300 transition-transform ease-in-out  ">
              {navbarLinks.map((navlink, index) => {
                return (
                  <button
                    onClick={() => {
                      navigate(navlink.nav);
                      setShowMobileMenu(false);
                    }}
                    key={index}
                    className={` ${
                      location.pathname === navlink.nav
                        ? "text-primary font-nunito  font-[500] "
                        : "font-nunito "
                    } hover:font-[600]  `}
                  >
                    {navlink.name}
                  </button>
                );
              })}
            </nav>
            {!theStoredToken && (
              <div className="flex flex-col w-full items-center justify-center gap-8">
                <button
                  onClick={() => {
                    navigate("/login");
                    setShowMobileMenu(false);
                  }}
                  className=" text-primary   "
                >
                  Login
                </button>
                <div className="w-full flex items-center justify-center">
                  <button
                    onClick={() => {
                      navigate("/sign-up");
                      setShowMobileMenu(false);
                    }}
                    className="w-[40%] h-[45px] bg-primary rounded-[4px] border-[1px]  text-white transition-all duration-500 ease-in-out   "
                  >
                    Get Started
                  </button>
                </div>
              </div>
            )}
            {theStoredToken && (
              <div className="w-full flex items-center justify-center">
                <button
                  onClick={() => {
                    navigate("/dashboard");
                    setShowMobileMenu(false);
                  }}
                  className="w-[40%] h-[45px] bg-primary rounded-[4px] border-[1px]  text-white transition-all duration-500 ease-in-out   "
                >
                  Profile
                </button>
              </div>
            )}
          </div>
        </header>
      )}
    </>
  );
};

export default Navbar;
